import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const activeTabSlice = createSlice({
    name: "activeTab",
    initialState: { value: "Overview" },
    reducers: {
        updateActiveTab: (state, action: PayloadAction<string>) => {
            state.value = action.payload;
        },
    },
});

export const { updateActiveTab } = activeTabSlice.actions;
export default activeTabSlice.reducer;
